import React from 'react';
import {PropertyList} from './PropertyList';
import {ContactDetails} from '../api/generated';
import {formatAddress, formatEmail, formatPhone} from '../lib/formaters';

export const ContactDetailsBlock: React.FC<{contactDetails: ContactDetails}> = ({
  contactDetails
}) => {
  return (
    <PropertyList
      omitEmpty
      properties={[
        {label: 'Name', value: contactDetails.name},
        {label: 'Email', value: formatEmail(contactDetails.email)},
        {
          label: 'Phone',
          value: formatPhone(contactDetails.phone, contactDetails.address?.country, true)
        },
        {label: 'Company', value: contactDetails.company},
        {label: 'Tax ID', value: contactDetails.taxId},
        {label: 'Address', value: formatAddress(contactDetails.address)}
      ]}
    />
  );
};
